import { Button, message, Modal, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { deleteVideo, uploadImg, uploadVideo } from '../../api/api'
import logo from '../../assets/logo.png'
import handleFileInUploading from '../../utils/cos'

const UploadlistTypeVideo = (props) => {
  const video = props.video
  const id = props.id
  const [fileList, setFileList] = useState(
    video === ''
      ? []
      : [
          {
            uid: '-1',
            name: `房源视频`,
            status: 'done',
            url: video,
          },
        ]
  )
  const [videoUrl, setVideoUrl] = useState(video === '' ? null : video)
  //向父组件传值
  const deliverUrl = props.deliverUrl

  //视频预览
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [previewTitle, setPreviewTitle] = useState('')
  const [isRemove, setIsRemove] = useState(false)

  const myUpload = (file) => {
    // //转化为formData格式
    const afterUpload = (url) => {
      setIsRemove(false)
      const video =
        'https://' + url.replace('cos.accelerate', 'cos-website.ap-shanghai')
      console.log(video)
      setFileList([
        {
          ...file,
          name: '房源视频',
          url: video,
          status: 'done',
        },
      ])
      deliverUrl(video)
      setVideoUrl(video)
      if ((url ?? false) && url !== '') {
        message.success('视频上传成功！')
      }
      // console.log(url);
    }
    handleFileInUploading(file.file, afterUpload)
  }

  const handleChange = ({ file, fileList }) => {
    console.log('handleCHange', file)
    if (file.status === 'uploading') {
      setFileList([
        {
          ...file,
          url: videoUrl,
          status: 'uploading',
        },
      ])
    }

    if (file.status === 'removed') {
      // deleteVideo(videoUrl, id).then((res) => {
      // console.log(res, '删除成功！')
      setVideoUrl('')
      setFileList([])
      // })
    }
  }

  function beforeUpload(file) {
    // console.log(file);
    const isJpgOrPng = file.type === 'video/mp4'
    if (!isJpgOrPng) {
      message.error('只能上传mp4文件!')
      return false
    }
    const isLt100M = file.size / 1024 / 1024 < 100
    if (!isLt100M) {
      message.error('视频大小需小于100MB!')
      return false
    }
    // console.log(file.type, 'test')
    return isJpgOrPng && isLt100M
  }

  const handlePreview = async (file) => {
    setPreviewImage()
    setPreviewOpen(true)
  }

  const handleCancel = () => setPreviewOpen(false)
  return (
    <>
      <Upload
        beforeUpload={beforeUpload}
        onChange={handleChange}
        customRequest={myUpload}
        fileList={fileList}
        onPreview={handlePreview}
        listType="picture"
        // onRemove={handleRemove}
      >
        {fileList.length >= 1 ? null : (
          <Button icon={<UploadOutlined />}>上传视频</Button>
        )}
      </Upload>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <video
          width="100%"
          height="600px;"
          controls="controls"
          id="video"
          src={videoUrl}
          preload="metadata"
        >
          您的浏览器不支持播放该视频！
        </video>
      </Modal>
    </>
  )
}

export default UploadlistTypeVideo
